import { conditionSlugs } from '@constants/common';

const getHubTags = condition => ({
  title: `Reviews for ${condition} Treatments | CureRate`,
  description: `Find ratings & reviews for ${condition} treatment products, supplements & recipes that will help you manage your condition. Sign up for free today to leave your own review!`
});

const getRecipesTags = condition => ({
  title: `${condition} Diet Recipes | CureRate`,
  description: `Find the best ${condition} diet recipes at CureRate. These recipes have been recommended as ${condition}-friendly by users with the same condition.`
});

const getStoriesTags = condition => ({
  title: `${condition} Natural Treatment Success Stories | CureRate`,
  description: `Find dietary, product & supplement suggestions from CureRate users who have provided their ${condition} natural treatment success stories. Sign up free today to share your story!`
});

export const conditionsMeta = {
  [conditionSlugs.pcos]: {
    hub: getHubTags('PCOS'),
    supplements: {
      title: 'Best Supplements for PCOS - Reviews & Ratings | CureRate',
      description:
        'At CureRate, you can find user reviews for the best supplements for PCOS that treat acne, hair loss, fertility issues & more. Sign up free today to leave a review!'
    },
    products: {
      title: 'Product Reviews - PCOS Treatments | CureRate',
      description:
        'Find product reviews for the treatment of PCOS symptoms, including hair loss, hirsutism, fertility issues, & more here at CureRate. Sign up today to leave your own review!'
    },
    recipes: getRecipesTags('PCOS'),
    combinations: getStoriesTags('PCOS')
  },
  [conditionSlugs.psoriasis]: {
    hub: getHubTags('Psoriasis'),
    supplements: {
      title: 'Best Natural Supplements for Psoriasis - Reviews | CureRate',
      description:
        'Find the best natural supplements for psoriasis at CureRate. We host unbiased user reviews by people with your condition. Sign up for free today to leave your review!'
    },
    products: {
      title: 'Remedies for Psoriasis - Product Reviews | CureRate',
      description:
        'Find relief from scaling, itching & dry skin with natural homeopathic remedies for psoriasis, rated & reviewed by users with the same condition. Sign up free today!'
    },
    recipes: getRecipesTags('Psoriasis'),
    combinations: getStoriesTags('Psoriasis')
  },
  [conditionSlugs['crohn-s']]: {
    hub: getHubTags("Crohn's"),
    supplements: {
      title: "Reviews - Natural Supplements for Crohn's Disease | CureRate",
      description:
        "Browse ratings & reviews of natural supplements for Crohn's disease by users with the same condition. Sign up on CureRate for free today to leave your own review!"
    },
    products: {
      title: "Product Reviews - Holistic Treatment for Crohn's | CureRate",
      description:
        "Find the best products for the holistic & natural treatment of Crohn's disease here at CureRate. Rated & reviewed by people with Crohn's. Sign up for free today!"
    },
    recipes: getRecipesTags("Crohn's"),
    combinations: getStoriesTags("Crohn's")
  },
  [conditionSlugs.ibs]: {
    hub: getHubTags('IBS'),
    supplements: {
      title: 'Best Supplements for IBS - Ratings & Reviews | CureRate',
      description:
        "Find natural relief from bloating, gas & diarrhea with CureRate's reviews of the best supplements for IBS. Rated & reviewed by users with IBS. Sign up for free today!"
    },
    products: {
      title: 'Product Reviews - Treatments for IBS | CureRate',
      description:
        'Looking for homeopathic treatment for IBS? The users at CureRate have rated & reviewed hundreds of alternative treatments for IBS so you can find the best products.'
    },
    recipes: getRecipesTags('IBS'),
    combinations: getStoriesTags('IBS')
  },
  [conditionSlugs['ulcerative-colitis']]: {
    hub: getHubTags('Ulcerative Colitis'),
    supplements: {
      title: 'Best Supplements for Ulcerative Colitis - Reviews | CureRate',
      description:
        'Find top-rated supplements for ulcerative colitis, reviewed by users with the same condition here at CureRate. Sign up today for free to leave your own review!'
    },
    products: {
      title:
        'Ulcerative Colitis Natural Treatments & Remedies - Reviews | CureRate',
      description:
        'Discover natural home remedies & alternative treatments for ulcerative colitis with CureRate reviews from users with the same condition. Sign up for free today!'
    },
    recipes: getRecipesTags('Ulcerative Colitis'),
    combinations: getStoriesTags('Ulcerative Colitis')
  }
};
